import { render, staticRenderFns } from "./waveDistribution.vue?vue&type=template&id=2d4544de&"
import script from "./waveDistribution.vue?vue&type=script&lang=js&"
export * from "./waveDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports